import api from './api';
import type { DismissTourResponse, OnboardingStatusResponse } from '../types/onboarding';

export const onboardingService = {
  getStatus: async (): Promise<OnboardingStatusResponse> => {
    const { data } = await api.get<OnboardingStatusResponse>('/admin/onboarding/status');
    return data;
  },

  dismissOptionalStep: async (stepId: string): Promise<{ message: string }> => {
    const { data } = await api.patch<{ message: string }>('/admin/onboarding/dismiss-step', {
      stepId,
    });
    return data;
  },

  dismissTour: async (): Promise<DismissTourResponse> => {
    const { data } = await api.patch<DismissTourResponse>('/admin/onboarding/tour-dismissed');
    return data;
  },

  updateTourProgress: async (stepId: string | null): Promise<{ message: string }> => {
    const { data } = await api.patch<{ message: string }>('/admin/onboarding/tour-progress', {
      stepId,
    });
    return data;
  },
};
